<template>
  <div class="tiaoShiKanBan">
    <h1 style="text-align: center; margin-top: 0vh; line-height: 8vh;">调试区域看板</h1>
    <el-date-picker
        v-model="selectDate"
        value-format="yyyy-MM-dd"
        type="date"
        clearable
        style="width: 6%; margin-left: 1%; margin-top: -5vh; float: left;"
        placeholder="选择日期"
        @change="getContentByDate"/>
    <table style="width: 100%; border: none;">
      <tr>
        <td v-show="ifShow" align="right" style="width: 33%">
          <span class="timeText">本年</span>
          <span
              ref="numberGrow1"
              :data-time="time"
              class="number-grow"
              :data-value="year">
            0
          </span>
        </td>
        <td align="center" style="width: 33%">
          <span class="timeText">本月</span>
          <span
              ref="numberGrow2"
              :data-time="time"
              class="number-grow"
              :data-value="month">
            0
          </span>
        </td>
        <td align="left" style="width: 33%">
          <span class="timeText">本日</span>
          <span
              ref="numberGrow3"
              :data-time="time"
              class="number-grow"
              :data-value="day">
            0
          </span>
        </td>
      </tr>
    </table>
    <div style="background-color: #2D4054; margin: 1vh 1vh 0vh 1vh;">
      <div style="width: 55%; float: left;">
        <div style="font-size: 3vh; float: left; margin: 1vh 0 0 1vh; position: absolute; z-index: 999;">* 调试</div>
        <div class="chart1" style="width: 47%; height: 30vh; float: left; margin-left: 6%;"/>
        <div class="chart2" style="width: 47%; height: 30vh; float: left;"/>
        <div class="clear"/>
      </div>
      <div style="width: 45%; float: right;">
        <el-table :data="DTSList" height="30vh" size="medium" style="font-size: 2.6vh;">
          <el-table-column prop="factoryNum" label="PC号" :width="fontSize(2.4)"/>
          <el-table-column prop="materialDescription" label="柜型" show-overflow-tooltip/>
        </el-table>
      </div>
      <div class="clear"/>
    </div>
    <div style="margin: 2vh 1vh 0vh 1vh;height: 44vh; overflow-y: hidden">
      <div style="font-size: 3vh;text-align: left; margin: 1vh 0 0 1vh;">* 人员产出数量</div>
      <table class="table" cellpading="0" cellspacing="0" style="width: 100%;height: 100%">
        <tr>
          <td style="font-weight: bold">姓名</td>
          <td>8:00</td>
          <td>9:00</td>
          <td>10:00</td>
          <td>11:00</td>
          <td>12:00</td>
          <td>13:00</td>
          <td>14:00</td>
          <td>15:00</td>
          <td>16:00</td>
          <td>17:00</td>
          <td>18:00</td>
          <td>19:00</td>
          <td>20:00</td>
          <td>21:00</td>
          <td>22:00</td>
          <td>23:00</td>
          <td>24:00</td>
          <td>总计</td>
        </tr>
        <tr v-for="(item,index) in OutputNumList" :key="index">
          <td style="font-weight: bold">{{item.scanMenName}}</td>
          <td>{{item.f8}}</td>
          <td>{{item.f9}}</td>
          <td>{{item.f10}}</td>
          <td>{{item.f11}}</td>
          <td>{{item.f12}}</td>
          <td>{{item.f13}}</td>
          <td>{{item.f14}}</td>
          <td>{{item.f15}}</td>
          <td>{{item.f16}}</td>
          <td>{{item.f17}}</td>
          <td>{{item.f18}}</td>
          <td>{{item.f19}}</td>
          <td>{{item.f20}}</td>
          <td>{{item.f21}}</td>
          <td>{{item.f22}}</td>
          <td>{{item.f23}}</td>
          <td>{{item.f24}}</td>
          <td>{{item.total}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        ifShow: new Date().toDateString() !== "Thu Sep 10 2020",
        date: new Date().getTime(),
        selectDate: "",
        time: 2,
        year: 0,
        month: 0,
        day: 0,
        myChart1: null,
        myChart2: null,
        lastDayTestPlanNum: 0,
        lastDayTestNum: 0,
        todayTestPlanNum: 0,
        todayTestNum: 0,
        DTSList: [],
        OutputNumList: [],
      };
    },
    mounted() {
      this.getSpDebuggingList();
      this.getDTSList();
      this.getPersonnelOutputNumList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      setInterval(() => {
        this.getSpDebuggingList();
        this.getDTSList();
        this.getPersonnelOutputNumList();
        this.date = new Date().getTime();
      }, 1000 * 60 * 5);
      setInterval(() => {
        this.DTSList.push(this.DTSList[0]);
        this.DTSList.splice(0, 1);
        this.OutputNumList.splice(0, 0, this.OutputNumList[this.OutputNumList.length - 1]);
        this.OutputNumList.splice(this.OutputNumList.length - 1, 1);
      }, 60000);
    },
    methods: {
      getContentByDate() {
        if (!this.selectDate) {
          this.date = new Date().getTime();
        } else {
          this.date = new Date(this.selectDate).getTime();
        }
        this.getSpDebuggingList();
        this.getDTSList();
        this.getPersonnelOutputNumList();
      },
      getSpDebuggingList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getSpDebuggingList", params).then(res => {
          console.log(res);
          for(let item of res) {
            if(item.name === "本年调试数量") {
              this.year = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本月调试数量") {
              this.month = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本日调试数量") {
              this.day = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天调试计划数量") {
              this.lastDayTestPlanNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天调试完成数量") {
              this.lastDayTestNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天调试计划数量") {
              this.todayTestPlanNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天调试完成数量") {
              this.todayTestNum = (item.bl === null ? 0 : item.bl);
            }
          }
          this.$nextTick(() => {
            this.numberGrow(this.$refs.numberGrow1);
            this.numberGrow(this.$refs.numberGrow2);
            this.numberGrow(this.$refs.numberGrow3);
            this.refreshChart();
          });
        });
      },
      getDTSList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getDTSList", params).then(res => {
          this.DTSList = res;
        });
      },
      getPersonnelOutputNumList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getPersonnelOutputNumList", params).then(res => {
          this.OutputNumList = res;
        });
      },
      refreshChart() {
        let option1 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n昨天\n调试\n数量",
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.2),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.25),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.lastDayTestNum/this.lastDayTestPlanNum, this.lastDayTestNum/this.lastDayTestPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                // formatter: ((this.lastDayTestNum/this.lastDayTestPlanNum) * 100).toFixed(2) + "%",
                formatter: this.lastDayTestNum + "\n\n总: " + this.lastDayTestPlanNum,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart1.setOption(option1);

        let option2 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n当天\n调试\n数量",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.2),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.25),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.todayTestNum/this.todayTestPlanNum, this.todayTestNum/this.todayTestPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                // formatter: ((this.todayTestNum/this.todayTestPlanNum) * 100).toFixed(2) + "%",
                formatter: this.todayTestNum + "\n\n总: " + this.todayTestPlanNum,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart2.setOption(option2);
      },
      numberGrow(ele) {
        if (ele.dataset.value < 40) {
          ele.innerHTML = ele.dataset.value;
          return;
        }
        let step = Math.floor((ele.dataset.value * 5) / (ele.dataset.time * 100));
        let current = 0;
        let start = 0;
        let t = setInterval(function() {
          start += step;
          if (start > ele.dataset.value) {
            clearInterval(t);
            start = ele.dataset.value;
            t = null;
          }
          if (current === start) {
            return;
          }
          current = start;
          ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
        }, 10);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .tiaoShiKanBan {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .table{
      tr{
        td{
          border-bottom: 1px solid #ffffff;
          padding: 3px 0;
          font-size: 2.2vh;
        }
      }
    }
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar{
      width: 0.2vh;
    }
    ::-webkit-scrollbar-thumb{
      border-radius: 0.2vh;
      height: 5vh;
      background: #eee;
    }
    ::-webkit-scrollbar-track{
      box-shadow: inset 0 0 5vh rgba(0, 0, 0, 0.2);
      border-radius: 0.2vh;
      background: rgba(0,0,0,0.4);
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .el-table__header-wrapper th:nth-last-of-type(2){
      border-right: none;
    }
    .el-table--border td:nth-last-of-type(1){
      border-right: none;
    }
    .el-table .cell {
       padding-left: 0px;
       padding-right: 0px;
     }
    .el-table--medium .el-table__cell {
      padding: 5px 0;
    }
    .clear{
      clear:both
    }
    .number-grow {
      font-family: Arial-BoldMT;
      font-size: 7vh;
      color: #81C3FF;
      letter-spacing: 0.267vh;
      line-height: 7vh;
      margin-left: 3%;
    }
    .timeText {
      font-family: Arial-BoldMT;
      font-size: 4vh;
      line-height: 7vh;
      color: #fff;
    }
  }
</style>
